export default {
  'sidebar.projects': 'Projects',
  'sidebar.projects.cohorts': 'Cohorts',
  // TODO: cleanup with data_reliability ff — top-level Data Reliability app
  'sidebar.data-reliability': 'Data Reliability',
  // TODO: cleanup with research_assistant_developer_tools ff — OR-6432 Block B,
  // internal-only top-level RA Session Review app
  'sidebar.ra-session-review': 'Session Review',
  'sidebar.users': 'Users',
  'sidebar.organizations': 'Organizations',
  'sidebar.sectionTitle.projects': 'Cohort Management',
  'sidebar.sectionTitle.sysAdmin': 'System Administration',
  'sidebar.extraction-accuracy': 'Results',
  'sidebar.sectionTitle.extractionAccuracy': 'Extraction Accuracy',
  'sidebar.concept-groups': 'Concept groups',
  'sidebar.analytical-variables': 'Variables',
  'sidebar.researchAssistant': 'Research Assistant (beta)',
  'sidebar.researchAssistant.tooltip.disabled':
    'Research Assistant is not currently supported on this page.',
};
